import throttle from 'lodash.throttle';
import React, { forwardRef, MutableRefObject } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { ResponsiveDetails } from './details';
type Props = {
  tableOfContents: string;
};

const Wrap = styled(ResponsiveDetails)`
  grid-area: tableOfContents;
  position: sticky;
  top: 3rem;
  align-self: start;
  justify-self: start;
  ${media.lessThan('large')`
    position: static;
  `}
`;

const Styled = styled.div`
  p {
    margin: 0.7rem 0;
  }
  a {
    font-size: 0.9rem;
    color: #888;
    ${media.lessThan('large')`
      color: #444;
    `}
    display: inline-block;
    text-decoration: none;
  }
  ul {
    list-style: none;
    padding-left: 1rem;
  }
  & > ul {
    margin: 0 0 0 1rem;
    padding: 0;
    & > li > a {
      &:before {
        content: none;
      }
    }
  }
`;

export const TableOfContents = forwardRef<HTMLDivElement, Props>(
  ({ tableOfContents }, ref) => {
    return (
      <Wrap summary="目次">
        <Styled
          dangerouslySetInnerHTML={{ __html: tableOfContents }}
          ref={ref}
        />
      </Wrap>
    );
  },
);

export const TableOfContentsHighlighter = (
  ref: MutableRefObject<HTMLDivElement>,
) => {
  if (typeof window !== `undefined` && window.innerWidth < 1171) {
    return;
  }
  const ul = ref.current.firstChild as HTMLElement;
  if (!ul) {
    return;
  }
  const aEntries = Object.entries(ul.getElementsByTagName('a'));
  const anchors: [HTMLAnchorElement, number][] = aEntries.map(([, v]) => [
    v,
    document.getElementById(decodeURI(v.hash).slice(1)).getBoundingClientRect()
      .top + window.scrollY,
  ]);
  let prevAnchor = anchors[0][0];
  const highlighter = (anchor: HTMLAnchorElement) => {
    prevAnchor.classList.remove('highlight');
    anchor.classList.add('highlight');
    prevAnchor = anchor;
  };
  window.addEventListener(
    'scroll',
    throttle(() => {
      const y = window.scrollY + window.innerHeight * 0.5;
      for (let i = 0; i < anchors.length; i++) {
        const anchor = anchors[i];
        if (anchor[1] < y && (!anchors[i + 1] || y < anchors[i + 1][1])) {
          highlighter(anchor[0]);
          break;
        }
      }
    }, 100),
  );
  window.dispatchEvent(new Event('scroll'));
};
